import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const BreadCrumbItem = ({ label, to, className, children, active }) => {
  return (
    <li className={className}>
      {children ? (
        children
      ) : (
        <Link to={to} style={{ color: active ? '#2e37a480' : '#2e37a4' }}>
          {label}
        </Link>
      )}
    </li>
  );
};

BreadCrumbItem.propTypes = {
  label: PropTypes.string,
  to: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.any,
  active: PropTypes.bool
};

export default BreadCrumbItem;
